var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveBackgroundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    xlinkHref: "#removeBackgroundIcon_svg__a",
    id: "removeBackgroundIcon_svg__b",
    patternTransform: "matrix(4.1025 3.6 -6.79552 7.74408 .302 .169)"
  }), /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    width: 2.5,
    height: 1,
    patternTransform: "scale(10)",
    id: "removeBackgroundIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h1v2H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.595 2.468V47.26h45.227V2.468H2.595zm20.33 13.046h16.632a3.162 3.162 0 013.169 3.169v17.84a3.162 3.162 0 01-3.17 3.168H22.926a3.162 3.162 0 01-3.17-3.168v-17.84a3.162 3.162 0 013.17-3.17z",
    fill: "url(#removeBackgroundIcon_svg__b)",
    stroke: "#000",
    strokeWidth: 2.681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRemoveBackgroundIcon;